// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
.Input_wrapper__BUDs1 {
  font-family: "Roboto Mono", "Arial", monospace;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
}

.Input_input__sM80e {
  font-size: 16px;
  line-height: 110%;
  font-family: inherit;
  color: #333333;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #8000FF;
  background-color: #FFFFFF;
  transition: all 0.5s;
  width: 100%;
}
.Input_input__sM80e::placeholder {
  color: rgba(51, 51, 51, 0.3764705882);
  opacity: 1;
  transition: color 0.5s;
}
.Input_input__sM80e:hover::placeholder {
  color: #333333;
}
.Input_input__sM80e:focus {
  outline: none;
}
.Input_input__sM80e:focus-visible::placeholder {
  color: #333333;
}
.Input_input__sM80e:disabled {
  border-color: rgba(51, 51, 51, 0.3764705882);
  color: rgba(51, 51, 51, 0.3764705882);
}

.Input_input__sM80e.Input_error__OABg\\+ {
  border-bottom: 1px solid #D60056;
}

.Input_error-message-wrapper__mJu1z {
  font-size: 12px;
  line-height: 110%;
  color: #D60056;
  display: flex;
  gap: 2px;
  align-items: center;
}

.Input_icon__HEp4C {
  align-self: start;
}

.Input_error-message__Ct8GV {
  flex-grow: 1;
}

.Input_remove__XEq9p {
  position: absolute;
  right: 0;
  top: 50%;
  translate: 0 -50%;
  background: #FFFFFF;
  border-radius: 8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/components/form/input/Input.module.sass","webpack://./src/assets/styles/mixins.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;ACjBA;EACI,8CDiBS;EChBT,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AACJ;;AACA;ECHI,eAAA;EACA,iBAAA;EDIA,oBAAA;EACA,cDFS;ECGT,YAAA;EACA,YAAA;EACA,gCAAA;EACA,yBDPS;ECQT,oBAAA;EACA,WAAA;AAGJ;AADI;EACI,qCDJM;ECKN,UAAA;EACA,sBAAA;AAGR;AADI;EACI,cDhBK;ACmBb;AADI;EACI,aAAA;AAGR;AADI;EACI,cDtBK;ACyBb;AADI;EACI,4CDlBM;ECmBN,qCDnBM;ACsBd;;AADA;EACI,gCAAA;AAIJ;;AAFA;EC/BI,eAAA;EACA,iBAAA;EDgCA,cD5BI;EC6BJ,aAAA;EACA,QAAA;EACA,mBAAA;AAMJ;;AAJA;EACI,iBAAA;AAOJ;;AALA;EACI,YAAA;AAQJ;;AANA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,iBAAA;EACA,mBDlDS;ECmDT,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AASJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@use \"../../../assets/styles/variables\" as *\r\n@use \"../../../assets/styles/mixins\" as mix\r\n\r\n.wrapper\r\n    font-family: $fm-primary\r\n    display: flex\r\n    flex-direction: column\r\n    gap: 2px\r\n    position: relative\r\n\r\n.input\r\n    @include mix.text-2\r\n    font-family: inherit\r\n    color: $base-black\r\n    padding: 8px\r\n    border: none\r\n    border-bottom: 1px solid $accent\r\n    background-color: $base-white\r\n    transition: all 0.5s\r\n    width: 100%\r\n\r\n    &::placeholder\r\n        color: $placeholder\r\n        opacity: 1\r\n        transition: color 0.5s\r\n    \r\n    &:hover::placeholder\r\n        color: $base-black\r\n\r\n    &:focus\r\n        outline: none\r\n\r\n    &:focus-visible::placeholder\r\n        color: $base-black\r\n    \r\n    &:disabled\r\n        border-color: $placeholder\r\n        color: $placeholder\r\n\r\n.input.error\r\n    border-bottom: 1px solid $error\r\n\r\n.error-message-wrapper\r\n    @include mix.text-3\r\n    color: $error\r\n    display: flex\r\n    gap: 2px\r\n    align-items: center\r\n\r\n.icon\r\n    align-self: start\r\n\r\n.error-message\r\n    flex-grow: 1\r\n\r\n.remove\r\n    position: absolute\r\n    right: 0\r\n    top: 50%\r\n    translate: 0 -50%\r\n    background: $base-white //Must use color theme\r\n    border-radius: 8px\r\n    width: 16px\r\n    height: 16px\r\n    cursor: pointer\r\n","@use \"./variables\" as *\r\n\r\n@mixin text-1\r\n    font-size: 20px\r\n    line-height: 120%\r\n\r\n@mixin text-2\r\n    font-size: 16px\r\n    line-height: 110%\r\n\r\n@mixin text-3\r\n    font-size: 12px\r\n    line-height: 110%\r\n\r\n@mixin container\r\n    max-width: $desktop-max\r\n    margin: 0 auto\r\n    width: calc(100vw - $desktop-offset * 2)\r\n\r\n    @media (max-width: $mobile-max)\r\n        width: calc(100vw - $mobile-offset * 2)\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Input_wrapper__BUDs1`,
	"input": `Input_input__sM80e`,
	"error": `Input_error__OABg+`,
	"error-message-wrapper": `Input_error-message-wrapper__mJu1z`,
	"icon": `Input_icon__HEp4C`,
	"error-message": `Input_error-message__Ct8GV`,
	"remove": `Input_remove__XEq9p`
};
export default ___CSS_LOADER_EXPORT___;
